export default "__VITE_ASSET__1ce8f3db__"